import { Typography, Box } from "@mui/material";
import React from "react";
import { useQuestion } from "../globals/QuestionContext";

export default function Requirements(props) {
  const question = useQuestion();
  let requirements = question?.requirements;

  React.useEffect(() => {
    requirements = question?.requirements;
  }, [question]);

  return (
    <Box sx={{ Maxheight: "100px" }}>
      <Typography variant="h4" textAlign="center">
        Requirements
      </Typography>
      <ul>
        {requirements?.map((requirement) => (
          <li key={requirement}>{requirement}</li>
        ))}
      </ul>
    </Box>
  );
}
